export default __webpack_public_path__ + "static/generative-art-9af4312f06dd99baa7d8a117a46a69e0.png";